import { useState } from 'react'
import { Button, FileButton, Text } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import { useOrpc } from '@/hooks/useClient'

// EOB/remittance attachment (accounting-plan Task 20 → Task 14 endpoint): the picked
// PDF uploads immediately (the endpoint is stateless) and the returned DocumentReference
// id is journaled by the saveEob / recordPayment calls the parent form passes it into.
type EobAttachmentProps = {
  encounterId: string
  onUploaded: (documentId: string) => void
}

export function EobAttachment({ encounterId, onUploaded }: EobAttachmentProps) {
  const orpc = useOrpc()
  const [fileName, setFileName] = useState<string | null>(null)

  const upload = useMutation(
    orpc.billingV2UploadEob.mutationOptions({
      onSuccess: (result: { documentId: string }, input: { file: File }) => {
        setFileName(input.file.name)
        onUploaded(result.documentId)
      },
    }),
  )

  return (
    <div className="flex items-center gap-3">
      <FileButton
        accept="application/pdf"
        onChange={(file) => {
          if (file) upload.mutate({ encounterId, file })
        }}
      >
        {(props) => (
          <Button {...props} variant="default" size="xs" loading={upload.isPending}>
            Attach EOB (PDF)
          </Button>
        )}
      </FileButton>
      {fileName ? (
        <Text size="sm" c="dark">
          {fileName}
        </Text>
      ) : null}
      {upload.isError ? (
        <Text size="sm" c="red">
          Failed to upload the EOB
        </Text>
      ) : null}
    </div>
  )
}
